import { useRedirectUrl } from "@/app/thankyou/hooks/use-redirect-url"
import { Channel } from "@/config/channel"
import { useConfigParams } from "@/hooks/use-config-params"
import { triggerSurveyOnce, TriggerType } from "@/lib/sandsiv/survey-utils"
import { useIpAddressQuery } from "@/services/get-ip-address"
import { usePathname } from "next/navigation"

export function useCloseWithSurveyAction(
  isThankYouPage: boolean,
  triggerSurveyFn: (
    pathname: string,
    channel: Channel,
    triggerType: TriggerType,
    ipAddress: string | null,
  ) => boolean,
) {
  const redirectUrl = useRedirectUrl()
  const pathname = usePathname()
  const { channel, cancelCallbackUrl } = useConfigParams()

  const ipAddressQuery = useIpAddressQuery()

  return () => {
    if (isThankYouPage) {
      window.location.assign(redirectUrl)
      return
    }

    const ipAddress = ipAddressQuery.data ?? null

    const surveyTriggered = triggerSurveyOnce(() =>
      triggerSurveyFn(pathname, channel, "cta", ipAddress),
    )

    // If the survey has been triggered, the user is viewing it, so do nothing.
    // Otherwise, redirect to the cancel callback URL.
    if (!surveyTriggered) {
      window.location.assign(cancelCallbackUrl)
    }
  }
}
